import { Button, Stack, Typography } from '@mui/material';
import { useDialog } from 'common/hooks/useDialog';
import { FilterConditionInput } from 'generated/graphql';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TagSelectDialog, TagSelectDialogProps } from '../selectDialogs/TagSelectDialog';
import { Filter } from './Filter';

const NAME = 'tags';
export const TagsFilter: React.FC = () => {
  const { t } = useTranslation();
  const { field: manualField } = useController({ name: `${NAME}.manual` });

  const tagsDialog = useDialog<TagSelectDialogProps, FilterConditionInput>(TagSelectDialog, {
    filter: manualField.value,
    instanceId: 'filter-transactions-select-tags',
    tmpNavigable: true,
  });

  const handleManualClick = async () => {
    try {
      const filter = await tagsDialog.create({ filter: manualField.value });
      manualField.onChange(filter);
    } catch (e) {
      //pass
    }
  };

  const isManual = !!manualField.value;

  return (
    <Filter
      name={NAME}
      onManualClick={handleManualClick}
      options={[]}
      title={t('filterTransactions.filter.tags.title')}
    >
      {isManual && (
        <Stack alignItems="center" direction="row" spacing={2}>
          <Typography>{manualField.value.values.join(', ')}</Typography>
          <Button color="tertiaryButton" onClick={handleManualClick}>
            <Typography color="blue.dark">{t('filterTransactions.filter.edit')}</Typography>
          </Button>
        </Stack>
      )}
    </Filter>
  );
};
